import { render, staticRenderFns } from "./CoolWhite.vue?vue&type=template&id=4d4e48d2&"
import script from "./CoolWhite.vue?vue&type=script&lang=js&"
export * from "./CoolWhite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports